import React, {useContext} from 'react';
import {ThemeContext} from 'styled-components';
import {
    white,
    gray70,
    gray50,
    actionColor,
    successColor,
    errorColor,
    warningColor,
    black,
} from '@propellerads/stylevariables';

import {StyledIcon} from './style';

import {
    SIZE,
    COLOR,
    Theme,
    IconProps,
} from './types';

const getColor = (color: COLOR | string, theme?: Theme): COLOR | string => {
    switch (color) {
        case COLOR.WHITE:
            return white;
        case COLOR.BLUE:
            return theme?.actionColor?.main || actionColor;
        case COLOR.GRAY:
            return gray70;
        case COLOR.GRAY_DARK:
            return gray50;
        case COLOR.SUCCESS:
            return theme?.successColor?.main || successColor;
        case COLOR.ERROR:
            return theme?.errorColor?.main || errorColor;
        case COLOR.WARNING:
            return theme?.warningColor?.main || warningColor;
        case COLOR.BLACK:
            return black;
        default:
            return color;
    }
};

interface Props extends IconProps{
    children: React.ReactNode
}

const Icon = ({
    children,
    size = SIZE.MEDIUM,
    color = COLOR.BLACK,
    hoverColor = COLOR.BLACK,
    onMouseEnter,
    onMouseLeave,
}: Props) => {
    const themeContext = useContext<Theme>(ThemeContext);

    return (
        <StyledIcon
            size={size}
            color={getColor(color, themeContext)}
            hoverColor={getColor(hoverColor, themeContext)}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            viewBox="0 0 24 24"
        >
            {children}
        </StyledIcon>
    );
};

export {Icon};
